// Default main language per country, used to pre-fill "Main Language" on the
// Add Beneficiary form when a country is chosen. Staff can still overtype it.
// The three live countries use what ground teams actually record for most
// children there (Gambia: Fulla, not English). The rest are the usual
// first language for a child in that country.
const COUNTRY_LANGUAGES = {
  somalia: 'Somali',
  kenya: 'Swahili',
  gambia: 'Fulla',
  tanzania: 'Swahili',
  uganda: 'Luganda',
  sudan: 'Arabic',
  yemen: 'Arabic',
  syria: 'Arabic',
  palestine: 'Arabic',
  egypt: 'Arabic',
  jordan: 'Arabic',
  lebanon: 'Arabic',
  iraq: 'Arabic',
  morocco: 'Arabic',
  pakistan: 'Urdu',
  bangladesh: 'Bengali',
  india: 'Hindi',
  afghanistan: 'Dari',
  turkey: 'Turkish',
  senegal: 'Wolof',
  nigeria: 'Hausa',
  ethiopia: 'Amharic',
  malawi: 'Chichewa',
  'sri lanka': 'Tamil',
  indonesia: 'Indonesian',
  myanmar: 'Rohingya'
};

export const getDefaultLanguage = country =>
  country ? COUNTRY_LANGUAGES[String(country).trim().toLowerCase()] : undefined;

export default COUNTRY_LANGUAGES;
